/**
 * Do not edit directly
 * Generated on Mon, 02 Feb 2026 08:48:11 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";